module.exports = __webpack_public_path__ + "hero-our-work.2pIn5h1m.png";